export const testRankingsStub = {
    batsmen: {
        rank: [
            {
                id: "10182",
                rank: "1",
                name: "Marnus Labuschagne",
                country: "Australia",
                rating: "892",
                points: "892",
                lastUpdatedOn: "2022-04-26",
                trend: "Flat",
                faceImageId: "184115"
            },
            // ... other batsmen
        ]
    },
    bowlers: {
        rank: [
            {
                id: "12345",
                rank: "1",
                name: "Pat Cummins",
                country: "Australia",
                rating: "900",
                points: "900",
                lastUpdatedOn: "2022-04-26",
                trend: "Flat",
                faceImageId: "184116"
            },
            // ... other bowlers
        ]
    },
    allrounders: {
        rank: [
            {
                id: "67890",
                rank: "1",
                name: "Ben Stokes",
                country: "England",
                rating: "850",
                points: "850",
                lastUpdatedOn: "2022-04-26",
                trend: "Flat",
                faceImageId: "184117"
            },
            // ... other allrounders
        ]
    },
    teams: {
        rank: [
            {
                id: "1",
                rank: "1",
                name: "India",
                rating: "120",
                points: "3205",
                matches: "27"
            },
            // ... other teams
        ]
    }
};
